//src/pages/projects/ProjectListPage.js
import React, { useEffect, useState } from "react";
import { getProjects, deleteProject } from "../../api/project/projectApi";
import { useNavigate } from "react-router-dom";
import { getMaterial } from "../../api/material/MaterialApi";
import { checkQuestionsExist, getQuestionCodes, updateAssessmentStatus,} from "../../api/questions/questionsApi";
import MaterialUpload from "../Materials/MaterialUpload";
import { FaEnvelope, FaPlay, FaStop, FaEye, FaPlusSquare, FaWhatsappSquare,} from "react-icons/fa";
import { MdCancel } from "react-icons/md";
// import Modal from "../../components/common/Modal"; // Assuming a reusable modal component
import { sendWhatsAppMessage, sendEmail } from "../../utils/share"; // Utility for sharing
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdAccountTree } from "react-icons/md";
import { LuGitPullRequestClosed } from "react-icons/lu";

const ProjectListPage = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [questionsExistMap, setQuestionsExistMap] = useState({});
  const [materialsCountMap, setMaterialsCountMap] = useState({});
  const [showAssessmentForm, setShowAssessmentForm] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [expandedProject, setExpandedProject] = useState(null); // Track expanded dropdown
  const [questionCodes, setQuestionCodes] = useState({}); // Store question codes per project
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    questionCode: "",
    url: "",
  });
  const [assessmentStatusMap, setAssessmentStatusMap] = useState({});
  const [projectID, setProjectID] = useState("");
  const user_id = localStorage.getItem("user_id");

  const backButtonHandler = () => {
    navigate("/dashboard");
  };

  const toggleAssessmentForm = (project) => {
    setSelectedProject(project);
    setShowAssessmentForm(!showAssessmentForm);
  };

  const viewResultsHandler = (projectId) => {
    navigate(`/assessment-results/${projectId}`);
  };

  const handleDeleteProject = async (projectId) => {
    try {
      await deleteProject(projectId);
      alert("Project deleted successfully!");
      fetchProjects();
    } catch (error) {
      alert("Failed to delete project");
      console.error("Error deleting project:", error);
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await getProjects(user_id);
      const projectData = response?.data?.projects || [];
      setProjects(projectData);

      
      for (const project of projectData) {
        const projectId = project.project_id;

       
        const materialsResponse = await getMaterial(user_id, projectId);
        setMaterialsCountMap((prev) => ({
          ...prev,
          [projectId]: materialsResponse.data.data.length,
        }));

        
        const exists = await checkQuestionsExist(projectId);
        setQuestionsExistMap((prev) => ({
          ...prev,
          [projectId]: exists,
        }));
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const viewMaterialListHandler = (projectId) => {
    navigate(`/material_list/${projectId}`);
  };

  const handleButtonClick = (projectId, materialsCount) => {
    if (questionsExistMap[projectId]) {
      navigate(`/view-questionnaire/${projectId}`);
    } else {
      navigate("/select-next-steps", { state: { projectId, materialsCount } });
      //navigate(`/create-assessment/step1/${projectId}`);
    }
  };

  
  const fetchQuestionCodes = async (projectId) => {
    if (!questionCodes[projectId]) {
      try {
        const codes = await getQuestionCodes(projectId); // Returns array of { question_code, assessment_status }
        //console.log('Fetched Codes:', codes);

     
        setQuestionCodes((prev) => ({ ...prev, [projectId]: codes }));

       
        const newStatusMap = {};
        codes.forEach(({ question_code, assessment_status }) => {
          newStatusMap[question_code] = assessment_status;
        });
        setAssessmentStatusMap((prev) => ({ ...prev, ...newStatusMap }));
      } catch (error) {
        console.error("Error fetching question codes:", error);
      }
    }
  };

  
  const toggleDropdown = (projectId) => {
    if (expandedProject === projectId) {
      setExpandedProject(null);
    } else {
      setExpandedProject(projectId);
      fetchQuestionCodes(projectId);
    }
  };

  
  const openModal = (questionCode, projectId) => {
    setModalContent({
      questionCode,
      url: process.env.REACT_APP_APP_URL, // Fetch from .env
    });
    setProjectID(projectId);

    setShowModal(true);
  };

  
  const today = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date());

  
  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (Object.keys(questionCodes).length > 0) {
      const newStatusMap = {};
      Object.keys(questionCodes).forEach((projectId) => {
        questionCodes[projectId]?.forEach((questionCode) => {
          if (!assessmentStatusMap[questionCode]) {
            newStatusMap[questionCode] = "live"; // Default to 'live'
          }
        });
      });
      setAssessmentStatusMap((prev) => ({ ...prev, ...newStatusMap }));
    }
  }, [questionCodes]);

  const handleToggleStatus = async (questionCode, currentStatus, projectId) => {
    const newStatus = currentStatus === "live" ? "stopped" : "live";
    const userId = localStorage.getItem("user_id");
    //console.log('Toggle Status Request:', { questionCode, newStatus, userId });

    try {
      await updateAssessmentStatus(questionCode, newStatus, userId);

     
      setAssessmentStatusMap((prev) => ({
        ...prev,
        [questionCode]: newStatus,
      }));

      alert(`Assessment status updated to ${newStatus}`);
    } catch (error) {
      console.error("Error updating assessment status:", error);
      alert("Failed to update assessment status. Please try again.");
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  

  return (
  <div className="w-full relative overflow-hidden">
  {/* <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-purple-400 opacity-20 blur-3xl rounded-full animate-float z-0"></div>
  <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2 z-0"></div> */}
  <div className="relative z-10">
 {showModal ? (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/40 backdrop-blur-sm px-4">
       <div className="w-full md:w-7/12 lg:w-5/12 bg-white rounded-2xl shadow-xl p-6 relative animate-fadeIn">
      <button
        onClick={closeModal}
        className="absolute top-3 right-3 text-red-500 hover:scale-110 transition text-2xl"
      >
        <MdCancel />
      </button>


      <div className="flex flex-col items-center text-center gap-4">

   
        <h1 className="text-xl md:text-2xl font-bold text-[#36369f]">
          Assessment Code
        </h1>

       
        <div className="w-full bg-indigo-50 border border-indigo-200 rounded-lg px-4 py-3">
          <p className="text-lg font-semibold text-gray-800 break-all">
            {modalContent.questionCode}
          </p>
        </div>

   
        <p className="text-sm md:text-base text-gray-600 break-all">
          {modalContent.url}
        </p>

      
        <button
          className="mt-2 bg-[#36369f] hover:bg-indigo-800 text-white px-6 md:px-10 py-2 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
          onClick={() => viewResultsHandler(projectID)}
        >
          View Dashboard
        </button>

      </div>
    </div>
  </div>
) : (
        <>
          {/* <img className="w-20 p-5 cursor-pointer" onClick={backButtonHandler} src={backicon} alt="Back"/> */}
          <div className="mt-6 mb-8 w-full flex items-center justify-between px-4 md:px-10 py-4 bg-white/60 backdrop-blur-md shadow-sm rounded-xl border border-gray-200">

  <button
    onClick={backButtonHandler}
    className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-full md:rounded-lg shadow-md hover:scale-105 transition-all duration-300"
  >
    <IoMdArrowRoundBack className="text-xl" />
    <span className="font-semibold hidden md:block">Back</span>
  </button>

  
  <h2 className="text-lg md:text-2xl font-bold bg-gradient-to-l from-indigo-950 to-indigo-800 bg-clip-text text-transparent">
    Your Projects
  </h2>

  <div className="hidden md:flex items-center px-6 py-2 bg-gradient-to-r from-green-400 to-emerald-500 text-white font-semibold rounded-lg shadow">
    {today}
  </div>

</div>

          
          {showAssessmentForm && selectedProject && (
            <div
              role="dialog"
              aria-modal="true"
              className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-55"
            >
              <div className="rounded-lg shadow-sm py-3 mb-3 w-full transform transition-transform duration-500 ease-out -translate-y-10 animate-slide-in">
                <MaterialUpload
                  project={selectedProject}
                  onClose={toggleAssessmentForm}
                />
              </div>
            </div>
          )}

         
          <div className="md:w-11/12 w-full mx-auto px-2 mb-10 ">
            <div className="h-[500px] overflow-y-auto rounded-2xl">
              <table className="min-w-full text-center border-collapse">
                <thead className="bg-gray-100 text-white lg:text-sm text-xs font-medium sticky top-0">
                  <tr className=" bg-[#36369f]  py-3">
                    <th className="lg:py-3 py-1.5 px-4">Status</th>
                    <th className="lg:py-3 py-1.5 px-4 text-left">
                      Assessment Name
                    </th>
                    <th className="lg:py-3 py-1.5 px-4">Upload Material</th>
                    <th className="lg:py-3 py-1.5 px-4">Learning Material</th>
                    <th className="lg:py-3 py-1.5 px-4">
                      Questions Overview /<br /> Create Questionnaire
                    </th>
                    <th className="lg:py-3 py-1.5 px-4">Assessment Result</th>
                  </tr>
                </thead>
                <tbody className="bg-white shadow-[inset_0px_4px_10px_rgba(0,0,0,0.1)]">
                  {projects.length > 0 ? (
                    projects.map((project) => {
                      const projectId = project.project_id;
                      const materialsCount = materialsCountMap[projectId] || 0;
                      const questionsExist =
                        questionsExistMap[projectId] || false;
                      const isExpanded = expandedProject === projectId;
                      const codes = questionCodes[projectId] || [];
                      return (
                        <>
                          <tr
                            key={projectId}
                            className="lg:text-base md:text-sm text-xs border-b border-gray-200 hover:bg-gray-50 cursor-pointer"
                          >
                            <td className="lg:p-4 md:p-2 p-2">
                              <button
                                className="text-blue-700 cursor-pointer"
                                onClick={() => toggleDropdown(projectId)}
                                aria-label={
                                  isExpanded
                                    ? "Collapse arrow button to hide assessment codes."
                                    : "Expand arrow button to view assessment codes."
                                }
                              >
                                {isExpanded ? (
                                  <LuGitPullRequestClosed className="lg:text-lg text-base" />
                                ) : (
                                  <MdAccountTree className="lg:text-lg text-base" />
                                )}
                              </button>
                            </td>
                            <td className="lg:p-4 md:p-2 text-left font-bold">
                              {project.project_name}
                            </td>
                            <td className="lg:p-4 md:p-3">
                              <button
                                className="w-full flex justify-center items-center md:gap-3 gap-1 text-blue-950  underline-offset-2 hover:underline hover:text-blue-700 cursor-pointer"
                                onClick={() => toggleAssessmentForm(project)}
                              >
                                <p>Upload</p>
                                <FaPlusSquare />
                              </button>
                            </td>
                            <td className="lg:p-4 md:p-3">
                              <button
                                className="w-full flex justify-center items-center md:gap-3 gap-1 text-blue-950  underline-offset-2 hover:underline hover:text-blue-700 cursor-pointer"
                                onClick={() =>
                                  viewMaterialListHandler(projectId)
                                }
                              >
                                <p>View</p>
                                <FaEye />
                              </button>
                            </td>
                            <td className="lg:p-4 md:p-3">
                              <button
                                className="text-blue-950  underline-offset-2 hover:underline hover:text-blue-700 cursor-pointer"
                                onClick={() =>
                                  handleButtonClick(projectId, materialsCount)
                                }
                                // disabled={materialsCount === 0}
                              >
                                {questionsExist ? (
                                  <div className="w-full flex justify-center items-center md:gap-3 gap-1">
                                    <p>Overview</p>
                                    <FaEye />
                                  </div>
                                ) : (
                                  "Create Questionnaire"
                                )}
                              </button>
                            </td>
                            <td className="lg:p-4 md:p-3">
                              <button
                                className="w-full flex justify-center items-center md:gap-3 gap-1 text-blue-950  underline-offset-2 hover:underline hover:text-blue-700 cursor-pointer"
                                onClick={() => viewResultsHandler(projectId)}
                                // disabled={materialsCount === 0}
                              >
                                <p>View</p>
                                <FaEye />
                              </button>
                            </td>
                          </tr>
                          {isExpanded && (
                            <tr>
                              <td
                                colSpan={6}
                                className="md:py-4 py-0 pt-2 px-12 border-b"
                              >
                                {codes.length > 0 ? (
                                  codes.map(({ question_code }) => (
                                    <div
                                      key={question_code}
                                      className="flex items-center justify-between bg-[#f8f9ff] px-4 py-2 rounded-lg mb-2 border border-gray-100">
                                      <p className="text-left md:text-sm text-xs mr-5">
                                        {question_code}
                                      </p>
                                   
                                      <button
                                     className={`flex items-center gap-2 px-4 py-1.5 text-xs md:text-sm font-semibold rounded-full text-white transition-all duration-300 ${
                                     assessmentStatusMap[question_code] === "live"
                                     ? "bg-green-500 hover:bg-green-600"
                                     : "bg-red-500 hover:bg-red-600"
                                     }`} 
                                        onClick={() =>
                                          handleToggleStatus(
                                            question_code,
                                            assessmentStatusMap[question_code],
                                            project.project_id
                                          )
                                        }
                                      >
                                        {assessmentStatusMap[question_code] ===
                                        "live" ? (
                                          <FaStop aria-label="Stop/Pause the assessment. This will prevent participants from taking the assessment." />
                                        ) : (
                                          <FaPlay aria-label="Play the assessment. This will allow participants to take the assessment." />
                                        )}
                                        <span className="ml-2">
                                          {assessmentStatusMap[
                                            question_code
                                          ] === "live"
                                            ? "Stop"
                                            : "Play"}
                                        </span>
                                      </button>

                                      
                                      <FaWhatsappSquare
                                        className="cursor-pointer text-blue-500 hover:scale-110 transition md:text-2xl text-base"
                                        onClick={() =>
                                          sendWhatsAppMessage(
                                            question_code,
                                            process.env.REACT_APP_APP_URL
                                          )
                                        }
                                        aria-label="Send Assessment code as a whatsapp message to participants"
                                      />
                                      <FaEnvelope
                                        className="cursor-pointer text-blue-500 md:text-xl text-base"
                                        onClick={() =>
                                          sendEmail(
                                            question_code,
                                            process.env.REACT_APP_APP_URL
                                          )
                                        }
                                        aria-label="Send Assessment code as an email to participants"
                                      />

                                      
                                      <button
                                        className=" flex justify-center items-center gap-1 text-blue-700 underline md:text-sm text-xs"
                                        onClick={() =>
                                          openModal(question_code, projectId)
                                        }
                                        aria-label="View - Click here to display the assessment code and link on full screen to display to participants."
                                      >
                                        <p>View</p>
                                        <FaEye />
                                      </button>
                                    </div>
                                  ))
                                ) : (
                                  <p className="text-gray-500 text-sm">
                                    No question codes available.
                                  </p>
                                )}
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        className="text-center text-xl font-semibold text-gray-600 my-2"
                      >
                        <div className="flex flex-col items-center justify-center py-10 text-gray-500">
                          <p className="text-lg font-semibold">No projects yet</p>
                          <p className="text-sm">Start by creating your first project</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* <div className="rounded-lg w-11/12 mx-auto">
              {projects.length > 0 ? (
                projects.map((project) => {
                  const projectId = project.project_id;
                  const materialsCount = materialsCountMap[projectId] || 0;
                  const questionsExist = questionsExistMap[projectId] || false;
                  const isExpanded = expandedProject === projectId;
                  const codes = questionCodes[projectId] || [];
                  return (
                    <div
                      key={projectId}
                      className="rounded-lg border-2 shadow-lg shadow-blue-300 py-3 mb-3"
                    >
                      <div className="flex">
                        <button
                          className="text-blue-700 cursor-pointer mx-2"
                          onClick={() => toggleDropdown(projectId)}
                          aria-label={
                            isExpanded
                              ? "Collapse arrow button to hide assessment codes."
                              : "Expand arrow button to view assessment codes."
                          }
                        >
                          {isExpanded ? <FaArrowDown /> : <FaArrowRight />}
                        </button>
                        <div className="w-4/12 text-left">
                          {project.project_name}
                        </div>
                        <button
                          className="md:w-3/12 w-10/12 text-blue-950 md:font-bold mx-2 md:text-sm text-[8px] underline-offset-2 hover:underline hover:text-blue-700 cursor-pointer"
                          onClick={() => toggleAssessmentForm(project)}
                        >
                          Upload Material +
                        </button>

                        <button
                          className="md:w-4/12 w-full text-blue-950 font-bold mx-2 md:text-sm text-[8px] underline-offset-2 hover:underline hover:text-blue-700 cursor-pointer"
                          onClick={() => viewMaterialListHandler(projectId)}
                        >
                          Learning Materials
                        </button>

                        <button
                          className="md:w-4/12 w-full text-blue-950 font-bold mx-2 md:text-sm text-[8px] underline-offset-2 text-decoration-thickness-2 hover:underline hover:text-blue-700 cursor-pointer"
                          onClick={() =>
                            handleButtonClick(projectId, materialsCount)
                          }
                          // disabled={materialsCount === 0}
                        >
                          {questionsExist
                            ? "Questions Overview"
                            : "Create Assessment"}
                        </button>

                        <button
                          className="md:w-4/12 w-full text-blue-950 font-bold mx-2 md:text-sm text-[8px] underline-offset-2 hover:underline hover:text-blue-700 cursor-pointer"
                          onClick={() => viewResultsHandler(projectId)}
                          // disabled={materialsCount === 0}
                        >
                          Assessment Results
                        </button>
                      </div>

                      {isExpanded && (
                        <div className="ml-8 my-5">
                          {codes.length > 0 ? (
                            codes.map(
                              ({ question_code, assessment_status }) => (
                                <div
                                  key={question_code}
                                  className="flex items-center mb-2 space-x-5"
                                >
                                  <p className="text-left text-sm mr-5">
                                    {question_code}
                                  </p>
                                  <button
                                    className={`flex items-center px-4 py-2 text-sm font-bold ${
                                      assessmentStatusMap[question_code] ===
                                      "live"
                                        ? "bg-green-500"
                                        : "bg-red-500"
                                    } text-white rounded`}
                                    onClick={() =>
                                      handleToggleStatus(
                                        question_code,
                                        assessmentStatusMap[question_code],
                                        project.project_id
                                      )
                                    }
                                  >
                                    {assessmentStatusMap[question_code] ===
                                    "live" ? (
                                      <FaStop />
                                    ) : (
                                      <FaPlay />
                                    )}
                                    <span className="ml-2">
                                      {assessmentStatusMap[question_code] ===
                                      "live"
                                        ? "Stop"
                                        : "Play"}
                                    </span>
                                  </button>
                                  <FaShareAlt
                                    aria-label="Share this code via WhatsApp."
                                    className="cursor-pointer text-green-500 mx-2"
                                    onClick={() =>
                                      sendWhatsAppMessage(
                                        question_code,
                                        process.env.REACT_APP_APP_URL
                                      )
                                    }
                                  />
                                  <FaEnvelope
                                    aria-label="Share this code via Email."
                                    className="cursor-pointer text-blue-500 mx-2"
                                    onClick={() =>
                                      sendEmail(
                                        question_code,
                                        process.env.REACT_APP_APP_URL
                                      )
                                    }
                                  />
                                  <button
                                    aria-label="Click to view the code in enlarged form."
                                    className="text-blue-700 underline text-sm"
                                    onClick={() =>
                                      openModal(question_code, projectId)
                                    }
                                  >
                                    View
                                  </button>
                                </div>
                              )
                            )
                          ) : (
                            <p className="text-gray-500 text-sm">
                              No question codes available.
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div>
                  <p className="text-center text-xl font-semibold text-gray-600 my-2">
                    No projects available.
                  </p>
                </div>
              )}
            </div> */}
          </div>
        </>
      )}
    </div>
    </div>
  );
};

export default ProjectListPage;
